import { render, staticRenderFns } from "./ListContratos.vue?vue&type=template&id=9ae9d52a"
import script from "./ListContratos.vue?vue&type=script&lang=js"
export * from "./ListContratos.vue?vue&type=script&lang=js"
import style0 from "./ListContratos.vue?vue&type=style&index=0&id=9ae9d52a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports